import { render } from "./chatRightList.vue?vue&type=template&id=74f45563"
import script from "./chatRightList.vue?vue&type=script&lang=js"
export * from "./chatRightList.vue?vue&type=script&lang=js"

import "./chatRightList.vue?vue&type=style&index=0&id=74f45563&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__